export const RESOURCE_TYPE_DEVOPS_REPORT_PRECONDITION = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
export const VIEW_DEV_TOOLS_PERMISSION_KEY = 'VIEW_DEV_TOOLS';
export const VIEW_AGGREGATED_DATA_PERMISSION_KEY = 'VIEW_AGGREGATED_DATA';
